import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private available = false;

  constructor() {
    this.available = this.storageAvailable('localStorage')
  }

  public setItem(key: string, value: string): void {
    if (!this.available)
      return;
    try {
      localStorage.setItem(key, value);
    } catch (ex) {
      console.error(ex);
      this.handleKnownErrors(ex);
    }
  }

  public getItem(key: string): string | null {
    if (!this.available)
      return;
    try {
      return localStorage.getItem(key);
    } catch (ex) {
      console.error(ex);
    }
  }

  public setItemAsJson(key: string, value: object): void {
    if (value)
      this.setItem(key, JSON.stringify(value));
    else
      this.removeItem(key);
  }

  public getItemAsJson(key: string): object | null {
    const value = this.getItem(key);
    if (value)
      return JSON.parse(value);
    return null;
  }

  public clear(): void {
    if (!this.available)
      return;
    try {
      localStorage.clear();
    } catch (ex) {
      console.error(ex);
    }
  }

  public key(index: number): string | null {
    if (!this.available)
      return;
    try {
      localStorage.key(index);
    } catch (ex) {
      console.error(ex);
    }
  }

  public removeItem(key: string): void {
    if (!this.available)
      return;
    try {
      localStorage.removeItem(key);
    } catch (ex) {
      console.error(ex);
    }
  }

  private handleKnownErrors(ex: any) {
    //https://newbedev.com/error-in-local-storage-ns-error-file-corrupted-firefox
    if (ex.name === "NS_ERROR_FILE_CORRUPTED") {
      if (localStorage && localStorage.clear)
        localStorage.clear();
      if (sessionStorage && sessionStorage.clear)
        sessionStorage.clear();
    }
  }

  private storageAvailable(type) {
    var storage;
    try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && (
        // everything except Firefox
        e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        (storage && storage.length !== 0);
    }
  }

}
